import qs from "qs"

/**
 * Get full Strapi URL from path
 * @param {string} path Path of the URL
 * @returns {string} Full Strapi URL
 */
export function getStrapiURL(path = "") {
  //return `https://onda.org.br${path}`
  return `${
    process.env.REACT_APP_STRAPI_API_URL || "https://onda.org.br"
  }${path}`
}

export interface UrlParams {
  populate?: string | string[] | Record<string, unknown>;
  filters?: Record<string, unknown>;
  pagination?: {
    page?: number;
    pageSize?: number;
    start?: number;
    limit?: number;
  };
  sort?: string | string[];
}

export interface ApiResponse<T = unknown> {
  data: T[];
  meta: {
    pagination: {
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  };
}


export interface ApiSingleResponse<T = unknown> {
  data: T;
  meta: Record<string, unknown>;
}

/**
 * Helper to make GET requests to Strapi API endpoints
 * @param {string} path Path of the API route
 * @param {Object} urlParamsObject URL params object, will be stringified
 * @param {Object} options Options passed to fetch
 * @returns Parsed API call response
 */
export async function fetchAPI<T = unknown>(path: string, urlParamsObject: UrlParams = {}, options = {}): Promise<ApiResponse<T>> {
  // Merge default and user options
  const mergedOptions = {
    headers: {
      "Content-Type": "application/json",
    },
    ...options,
  }

  // Build request URL
  const queryString = qs.stringify(urlParamsObject)
  const requestUrl = `${getStrapiURL(
    `/api${path}${queryString ? `?${queryString}` : ""}`
  )}`

  // Trigger API call
  const response = await fetch(requestUrl, mergedOptions)

  // Handle response
  if (!response.ok) {
    if (process.env.NODE_ENV === 'development') {
      console.error('API Error:', response.statusText)
    }
    throw new Error(`Erro na requisição: ${response.status} - ${response.statusText}`)
  }
  const data = await response.json()
  return data
}

/**
 * Helper to make GET requests to Strapi API endpoints
 * @param {string} path Path of the API route
 * @param {Object} urlParamsObject URL params object, will be stringified
 * @param {Object} options Options passed to fetch
 * @returns Parsed API call response
 */
 export async function fetchSingleAPI<T = unknown>(path: string, urlParamsObject: UrlParams = {}, options = {}): Promise<ApiSingleResponse<T>> {
  // Merge default and user options
  const mergedOptions = {
    headers: {
      "Content-Type": "application/json",
    },
    ...options,
  }

  // Build request URL
  const queryString = qs.stringify(urlParamsObject)
  const requestUrl = `${getStrapiURL(
    `/api${path}${queryString ? `?${queryString}` : ""}`
  )}`

  // Trigger API call
  const response = await fetch(requestUrl, mergedOptions)

  // Handle response
  if (!response.ok) {
    if (process.env.NODE_ENV === 'development') {
      console.error('API Error:', response.statusText)
    }
    throw new Error(`Erro na requisição: ${response.status} - ${response.statusText}`)
  }
  const data = await response.json()
  return data
}

export async function fetchGraphql<T = unknown>(query: {query: string}): Promise<T> {
  const requestUrl = getStrapiURL(`/graphql`)

  let options = {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(query)
    //'{"query":"query {\n  blogs(\n    sort: [\"date:desc\", \"important:desc\", \"createdAt:desc\"], \n    pagination: {start: 0, limit: 3}\n  ) {\n    data {\n      id,\n      attributes {\n        title,\n        description,\n        body,\n        author,\n        link_img,\n        date,\n        index\n      }\n  \t}\n  },\n  normas {\n    meta {\n      pagination {\n        total\n      }\n    }\n  },\n  decisions {\n    meta {\n      pagination {\n        total\n      }\n    }\n  },\n  dissertations {\n    meta {\n      pagination {\n        total\n      }\n    }\n  }\n}"}'
  };

  const response = await fetch(requestUrl, options)

  // Handle response
  if (!response.ok) {
    if (process.env.NODE_ENV === 'development') {
      console.error('API Error:', response.statusText)
    }
    throw new Error(`Erro na requisição: ${response.status} - ${response.statusText}`)
  }
  const data = await response.json()
  return data
}
